import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../utils/firebase';

const PendingApproval = () => {
	const navigate = useNavigate();


	const handleLogout = async () => {
		try {
			// Sign out the user from Firebase
			await signOut(auth);
			console.log('User successfully logged out');

			// Navigate to the welcome page
			navigate('/welcome');
		} catch (error) {
			console.error('Error signing out:', error);
		}
	};

	return (
		<div className="min-h-screen bg-gradient-to-br from-zinc-900 via-zinc-900/95 to-zinc-950 flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8">
			<div className="max-w-md w-full bg-slate-900/50 backdrop-blur-xl rounded-xl border border-slate-800 shadow-lg overflow-hidden">
				<div className="p-8 text-center">
					<h2 className="text-3xl font-extrabold text-white mb-4">
						Account Pending Approval
					</h2>
					<p className="text-slate-400 mb-4">
						Your account is currently awaiting approval. You’ll receive an email notification once the
						review is complete.
					</p>
					<p className="text-sm text-slate-500">
						Approvals typically take 1-2 business days. Please be patient while we process your request.
					</p>
					<button
						onClick={handleLogout}
						className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200"
					>
						Logout
					</button>
				</div>
				<div className="bg-slate-800/50 border-t border-slate-700 p-4 text-center">
					<p className="text-slate-400 text-sm">
						Need assistance?{" "}
						<a
							href="mailto:recoveryhouseplatform@gmail.com"
							className="text-red-500 hover:text-red-600 font-medium"
						>
							Contact support
						</a>
					</p>
				</div>
			</div>
		</div>
	);
};

export default PendingApproval;
